import React from "react";
import request from "request"
import usesFeatures from "usesFeatures"
import { CardElement } from '@stripe/react-stripe-js';

// Simplified copy of PaymentRequired from Customer Checkout app( aka Mobile Ordering)
// rn PaymentRequired allows to bypass Stripe payment
// both components need to be reworked

class ManualCardPayment extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      paymentComplete: false,
      payment: null,
      loadingPayment: true,
      paymentError: null
    }
  }

  componentDidMount() {
    this.createPaymentIntent()
  }

  createPaymentIntent = () => {
    const { order } = this.props
    if (!order || !order.id) return

    this.setState({ loadingPayment: true, paymentError: null })

    const req = request.post(`/payments/manual`, { order_id: order.id })
    req.then(({data}) => {
      this.setState({
        payment: data.payment,
        loadingPayment: false
      })
    })
    req.catch(({response}) => {
      this.setState({
        paymentError: "Failed to create payment intent",
        loadingPayment: false
      })
    })
  }

  updateCard = (ev) => this.setState({ paymentComplete: ev.complete })

  canSubmit = () => {
    if (this.state.processing) return false
    if (!this.state.paymentComplete) return false
    return true
  }

  handleSubmit = (event) => {
    this.setState({paymentError: null, processing: true})
    if (!this.canSubmit()) return false
    event.preventDefault();

    if (!this.props.stripe || !this.props.elements) {
      return;
    }

    const { stripe, elements } = this.props
    const { payment } = this.state
    const cardElement = elements.getElement(CardElement);

    if (!payment || !payment.intentSecret) {
      this.setState({ paymentError: "Payment intent not available", processing: false })
      return false
    }

    let stripePayment = stripe.confirmCardPayment(payment.intentSecret, {
      payment_method: {
        card: cardElement,
      }
    })

    stripePayment.then((result) => {
      if (result.error) {
        this.setState({paymentError: result.error.message, processing: false})
      }

      if (result.paymentIntent && result.paymentIntent.status == "requires_capture") {
        let req = request.post("/payments ", { manual_cc: true, order_id: this.props.order.id })
        req.then(({data}) => this.props.onComplete(this.props.order))
      }
    })
  }

  render() {
    const { order } = this.props
    const { loadingPayment, paymentError, payment } = this.state

    if (loadingPayment) {
      return (
        <div className="PaymentRequired mt-4">
          <h3 className="subtitle" style={{marginLeft: -10 }}>
            Total ${order?.total}
          </h3>
          <div className="has-text-centered mt-5">
            <p>Setting up payment...</p>
          </div>
        </div>
      )
    }

    if (paymentError && !payment) {
      return (
        <div className="PaymentRequired mt-4">
          <h3 className="subtitle" style={{marginLeft: -10 }}>
            Total ${order?.total}
          </h3>
          <div className="notification is-danger is-light mt-4">
            <p>{paymentError}</p>
            <button
              className="button is-small mt-2"
              onClick={this.createPaymentIntent}
            >
              Try Again
            </button>
          </div>
        </div>
      )
    }

    return(
      <div className="PaymentRequired mt-4">
        <h3 className="subtitle" style={{marginLeft: -10 }}>
          Total ${order?.total}
        </h3>

          <div className="field block">
            <label className="label">&nbsp;</label>
            <CardElement
              onChange={this.updateCard}
              options={{
                style: {
                  base: {
                    fontSize: '16px',
                    color: '#424770',
                    '::placeholder': {
                      color: '#888',
                    },
                  },
                  invalid: {
                    color: '#9e2146',
                  },
                },
              }}
            />
          </div>

          { this.state.paymentError &&
            <p className="Error notification is-danger is-light">
              Payment Error: { this.state.paymentError }
            </p>
          }

          <button
            disabled={!this.canSubmit()}
            onClick={this.handleSubmit}
            className="button is-primary mt-5 is-fullwidth"
          >
            { this.state.processing ? "Processing…" : "Pay Now" }
          </button>
      </div>
    )
  }
}

export default usesFeatures(["payments"], ManualCardPayment)
